import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/empty/empty-materials.svg'


const _hoisted_1 = { class: "px-8 pb-0 w-full" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "min-h-[600px]"
}
const _hoisted_4 = { class: "w-full min-h-[600px] flex flex-col justify-center items-center space-y-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_6 = { class: "font-bold text-gray-700" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MaterialLoad = _resolveComponent("MaterialLoad")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.showModal,
    "onUpdate:visible": [
      _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showModal) = $event)),
      _ctx.onCloseMaterialsModal
    ],
    draggable: false,
    breakpoints: { '960px': '95vw', '640px': '95vw' },
    style: { width: '65vw', minWidth: '360px' },
    modal: true,
    contentStyle: "",
    class: "dialog"
  }, {
    header: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("h4", null, _toDisplayString(_ctx.$t("labels.generic", {
              pt: `Visualizar objetos`,
              en: `View objects`,
            })) + " - " + _toDisplayString(_ctx.learningObjective?.name), 1)
      ])
    ]),
    default: _withCtx(() => [
      (_ctx.materials?.length > 0)
        ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
            _createVNode(_component_MaterialLoad, {
              currentMaterial: 
          _ctx.materials.length > 1 ? _ctx.materials[_ctx.indexMaterial] : _ctx.materials[0]
        ,
              materials: _ctx.materials,
              indexMaterial: _ctx.indexMaterial,
              maxIndexMaterial: _ctx.config.maxIndexMaterial,
              typeModalHeader: _ctx.config.typeModalHeader,
              isAdaptativeLearning: _ctx.isAdaptativeLearning,
              onOnChooseMaterial: _ctx.onChooseMaterial,
              onOnDeleteObject: _ctx.onDeleteObject,
              onOnGoToEditObject: _ctx.onGoToEditObject,
              ref: "materialLoad"
            }, null, 8, ["currentMaterial", "materials", "indexMaterial", "maxIndexMaterial", "typeModalHeader", "isAdaptativeLearning", "onOnChooseMaterial", "onOnDeleteObject", "onOnGoToEditObject"])
          ]))
        : (_openBlock(), _createElementBlock("section", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("labels.generic", {
              pt: `Nenhum objeto adicionado`,
              en: `No objects added`,
            })), 1),
              (_ctx.user?.role === 'TEACHER')
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    class: "btn-outline flex justify-center items-center",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onGoToObjective()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        name: "md-add",
                        class: "text-primary-400"
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("labels.generic", {
              pt: `Adicionar objetos`,
              en: `Add objects`,
            })), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ]))
    ]),
    _: 1
  }, 8, ["visible", "onUpdate:visible"]))
}